import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const PaymentRequiredPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  const handleViewPlans = () => {
    navigate('/plans');
  };

  const handleContactSupport = () => {
    // In a real app, this would open a support contact form or email
    window.open('mailto:support@example.com', '_blank');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md mx-auto p-8 bg-white rounded-lg shadow-md">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Payment Required</h2>
        <p className="text-gray-600 mb-6">
          Access to this feature requires an active subscription. Please choose a plan to continue.
        </p>
        <div className="space-y-3">
          <button
            onClick={handleViewPlans}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            View Subscription Plans
          </button>
          <button
            onClick={handleContactSupport}
            className="w-full px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Contact Support
          </button>
        </div>
        {from && from !== '/dashboard' && (
          <p className="text-sm text-gray-500 mt-4">
            You were trying to access: <span className="font-medium">{from}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentRequiredPage;